var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMatific)?_c('a',{class:_vm.classes,on:{"click":function($event){return _vm.initMatific()}}},[_vm._t("content")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }